/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
*/
import React, { lazy, Suspense, useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../Body/Body.css";
import MediaQuery from "react-responsive";

const Form = lazy(() => import("../../components/SignUpForm/SignUpForm"));




export default function Body({ links }) {
  const imgCDNURL = process.env.REACT_APP_CDN_CMSPOSTEVENT;
  const imgCDNURL1 = process.env.REACT_APP_PASADENA_POSTEVENT_CDN_URL;

  return (
    <>
      <div className="banner">
        <Container className="bannercontainer">
          <Row>
            <Col sm={12} md={12} xl={6} lg={6} xxl={7}>
              <div className="bannertextstag">
                <p className="mastertitle">
                  The Rise of Ai: {" "}
                  <MediaQuery maxWidth={991}>
                    <br />
                  </MediaQuery>
                  Use It or Lose It
                </p>
                <p>
                  <span className="dot mastertitle1">
                    No Tough Loans
                    <span class="dot ps-1">
                      <img src={imgCDNURL + 'oragne-ellipse.webp'} className="dotimg" />
                    </span>{" "}
                    Close Fast
                    <span class="dot ps-1">
                      <img src={imgCDNURL + 'oragne-ellipse.webp'} className="dotimg" />
                    </span>{" "}
                    Earn More
                  </span>
                </p>
                <MediaQuery minWidth={992}>
                  <div>
                    <p className="mastertitle4">
                      <span style={{ color: "#EE6124" }}>California Mortgage Expo:</span> <br></br>
                      Building Bonds and Creating <br></br>
                      Lasting Memories
                    </p>
                  </div>
                </MediaQuery>
                {/* <img src={imgCDNURL + "angelai-banner.webp"} className="bannerlogo"></img> */}
                <a href="https://www.swmc.com/angelai/" target="_blank" rel="noreferrer">
                  <img src={imgCDNURL1 + "Angel-AI.webp"} className="banner-logo" title="AngelAi Logo" alt="AngelAi Logo"></img>
                </a>
                <MediaQuery maxWidth={991}>
                <div>
                  <p className="mastertitle4">
                    <span style={{ color: "#EE6124" }}>California Mortgage Expo:</span> {" "}
                    Building Bonds and Creating Lasting Memories
                  </p>
                </div>
                </MediaQuery>
              </div>
            </Col>
            <Col sm={12} md={12} xl={6} lg={6} xxl={5}>
              <div className="formsection">
                <Suspense fallback={<div />}>
                    <Form />
                </Suspense>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}
